__turbopack_context__.v({
  "activeDot": "ProductMediaCarousel-module-scss-module__y0s7_G__activeDot",
  "brewDivider": "ProductMediaCarousel-module-scss-module__y0s7_G__brewDivider",
  "brewFooter": "ProductMediaCarousel-module-scss-module__y0s7_G__brewFooter",
  "brewHeader": "ProductMediaCarousel-module-scss-module__y0s7_G__brewHeader",
  "brewIcon": "ProductMediaCarousel-module-scss-module__y0s7_G__brewIcon",
  "brewOverlay": "ProductMediaCarousel-module-scss-module__y0s7_G__brewOverlay",
  "brewSteps": "ProductMediaCarousel-module-scss-module__y0s7_G__brewSteps",
  "carousel": "ProductMediaCarousel-module-scss-module__y0s7_G__carousel",
  "controls": "ProductMediaCarousel-module-scss-module__y0s7_G__controls",
  "dot": "ProductMediaCarousel-module-scss-module__y0s7_G__dot",
  "dotInner": "ProductMediaCarousel-module-scss-module__y0s7_G__dotInner",
  "dots": "ProductMediaCarousel-module-scss-module__y0s7_G__dots",
  "imageSlide": "ProductMediaCarousel-module-scss-module__y0s7_G__imageSlide",
  "paused": "ProductMediaCarousel-module-scss-module__y0s7_G__paused",
  "playPauseBtn": "ProductMediaCarousel-module-scss-module__y0s7_G__playPauseBtn",
  "preload": "ProductMediaCarousel-module-scss-module__y0s7_G__preload",
  "stepText": "ProductMediaCarousel-module-scss-module__y0s7_G__stepText",
  "stepTime": "ProductMediaCarousel-module-scss-module__y0s7_G__stepTime",
  "video": "ProductMediaCarousel-module-scss-module__y0s7_G__video",
  "videoSlide": "ProductMediaCarousel-module-scss-module__y0s7_G__videoSlide",
  "viewport": "ProductMediaCarousel-module-scss-module__y0s7_G__viewport",
});
